import FormuleFormController from './formule.form.controller';

export default {
    bindings: {
        modalInstance: '='
    },
    template: require('./formule.form.html'),
    controller: FormuleFormController
};
